import { Check } from "lucide-react";
import { marketplaceBuyerProgressLabels, marketplaceBuyerProgressStep } from "@gaole/shared";
import { useAuth } from "../../stores/auth";

export function MarketplaceOrderProgress({
  fulfilmentMethod,
  sellerFulfilmentStatus,
  buyerConfirmed,
}: {
  fulfilmentMethod?: string;
  sellerFulfilmentStatus?: string | null;
  buyerConfirmed?: boolean;
}) {
  const { config } = useAuth();
  const labels = marketplaceBuyerProgressLabels(fulfilmentMethod, config?.marketplaceCollectLabel);
  const step = marketplaceBuyerProgressStep(
    fulfilmentMethod ?? "DELIVERY",
    sellerFulfilmentStatus,
    Boolean(buyerConfirmed),
  );
  if (step < 0) return null;

  return (
    <div className="rounded-2xl border border-white/5 bg-surface p-4">
      <div className="flex items-center">
        {labels.map((label, i) => (
          <div key={label} className="flex flex-1 items-center last:flex-none">
            <div
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[9px] font-bold ${
                i <= step ? "bg-gradient-brand text-white" : "bg-white/10 text-white/40"
              }`}
            >
              {i < step ? <Check size={10} strokeWidth={3} /> : i + 1}
            </div>
            {i < labels.length - 1 && (
              <div className={`h-0.5 flex-1 ${i < step ? "bg-brand-pink" : "bg-white/10"}`} />
            )}
          </div>
        ))}
      </div>
      <div className="mt-2 flex justify-between text-[8px] uppercase tracking-wide text-white/40">
        {labels.map((label) => (
          <span key={label} className="max-w-[4.5rem] text-center leading-tight">
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
